import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Lock, KeyRound } from "lucide-react";

// Shown on a cleaner's finished turnover: proves the access details are no longer available.
export default function AccessLockedNote({ bookingId }) {
  const [state, setState] = useState(null);

  useEffect(() => {
    api.get(`/bookings/${bookingId}/access`)
      .then((r) => setState(r.data))
      .catch(() => setState({ visible: false }));
  }, [bookingId]);

  if (!state) return null;
  const hidden = !state.visible;

  return (
    <div className={`mt-3 flex items-start gap-2 p-3 rounded-xl text-sm ${hidden ? "bg-secondary/60 text-muted-foreground" : "bg-accent/5 text-foreground"}`}
      data-testid={hidden ? `access-locked-${bookingId}` : `access-still-visible-${bookingId}`}>
      {hidden ? <Lock className="h-4 w-4 shrink-0 mt-0.5" /> : <KeyRound className="h-4 w-4 shrink-0 mt-0.5 text-accent" />}
      <span>
        {hidden
          ? "Property access details are hidden — this job is complete."
          : "Access details are still available for this job."}
      </span>
    </div>
  );
}
